module.exports = require('./lib/speakingurl');



//////////////////
// WEBPACK FOOTER
// ./~/speakingurl/index.js
// module id = 792
// module chunks = 7